import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';

import { isEmpty } from 'lodash-es';

import * as fromWalkingFarmActions from '../../../../../../store/actions/walking-farm.actions';

interface RenameFarmFormGroup {
  name: FormControl<string | null>;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-rename-farm-modal',
  standalone: false,
  templateUrl: './rename-farm-modal.component.html'
})
export class RenameFarmModalComponent {
  private modalController = inject(ModalController);
  private store = inject(Store);

  form: FormGroup<RenameFarmFormGroup> = new FormGroup<RenameFarmFormGroup>({
    name: new FormControl<string>('', Validators.required)
  });

  farmId = '';
  nameValue = '';

  set name(value: string) {
    this.nameValue = value;
    this.form.controls.name.setValue(value);
  }

  get name() {
    return this.nameValue;
  }

  close() {
    return this.modalController.dismiss(null, 'cancel');
  }

  async save() {
    const newName = this.form.getRawValue().name;

    if (this.farmId && !isEmpty(newName)) {
      this.store.dispatch(
        fromWalkingFarmActions.updateName({
          payload: {
            farmId: this.farmId,
            name: this.form.getRawValue().name ?? ''
          }
        })
      );
    }
    await this.close();
  }
}
